export const environment = {
  production: true,
  appTitle: 'ΕΚΑΠΥ - Σύστημα Διαλειτουργικότητας',
  appSubtitle: 'Εθνική Κεντρική Αρχή Προμηθειών Υγείας',
  appTitleShort: 'ΕΚΑΠΥ - Διαλειτουργικότητα',
  appTitleInner: 'ΣΥΣΤΗΜΑ ΔΙΑΛΕΙΤΟΥΡΓΙΚΟΤΗΤΑΣ',
  environmentName: 'stage',
  ROOT_FOLDER: '',
  appUrl: 'https://stageinterop.ekapy.gov.gr',
  apiUrl: 'https://stageinterop.ekapy.gov.gr/Api',
  appVersion: '0.0.6',
  useMock: false,
  defaultFileSettings: {
    maxFileSizeMB: 40,
    finalMaxFileSizeMB: 42, //if a request exceeds the finalMaxFileSizeMB there is an error both on the iis/azure and the server side
    allowedExtentions: '.pdf,.jpeg,.jpg,.gif,.x-png,.png',
  },
};
